<ng-container *ngIf="isReady">
  <ng-content *ngIf="hasRecords"></ng-content>
  <div *ngIf="!hasRecords && !isLoading" class="no-records-message">
    {{ noResultsMessage }}
  </div>
</ng-container>

